import React from 'react';
import {
  useTable,
  useSortBy,
  useResizeColumns,
  useGlobalFilter,
  useAsyncDebounce
  // usePagination,
} from "react-table";
import {
  Tabs, Tab, Table, Button, FormGroup,
  InputGroup,
  FormControl,
  Alert as BSALert
} from "react-bootstrap";
import { DateTime } from "luxon";
import { injectIntl } from 'react-intl';



function GlobalFilter({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
  intl
}) {
  const [value, setValue] = React.useState(globalFilter)
  const onChange = useAsyncDebounce(value => {
    setGlobalFilter(value || undefined)
  }, 200)
  return (
    <div className="text-right search-container">
      <FormGroup>
        <InputGroup value={value || ""} onChange={e => {
          setValue(e.target.value);
          onChange(e.target.value);
          }
        }>
          <FormControl placeholder={intl.formatMessage({id: "search.email"})} type="text" />
          <InputGroup.Append>
            <Button>
              <img src="/icons/search.png" alt="plus" />
            </Button>
          </InputGroup.Append>
        </InputGroup>
      </FormGroup>
    </div>
  )
}


function ReactTable({ columns, data, intl }) {
  // Use the state and functions returned from useTable to build your UI

  const filterTypes = React.useMemo(
    () => ({
      // Or, override the default text filter to use
      // "startWith"
      text: (rows, id, filterValue) => {
        return rows.filter(row => {
          const rowValue = row.values[id]
          console.log(rowValue);
          return rowValue !== undefined
            ? String(rowValue)
              .toLowerCase()
              .startsWith(String(filterValue).toLowerCase())
            : true
        })
      },
    }),
    []
  )

  // const defaultColumn = React.useMemo(
  //   () => ({
  //     // Let's set up our default Filter UI
  //     Filter: DefaultColumnFilter,
  //   }),
  //   []
  // )

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    // page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active page
    rows,
    state,
    preGlobalFilteredRows,
    setGlobalFilter
    // The rest of these things are super handy, too ;)
    // canPreviousPage,
    // canNextPage,
    // pageOptions,
    // pageCount,
    // gotoPage,
    // nextPage,
    // previousPage,
    // setPageSize,
  } = useTable(
    {
      columns,
      data,
      filterTypes,
      initialState: {
        sortBy: [
          {
            id: "timestamp",
            desc: true,
          },
        ],
      },
    }, useGlobalFilter, useSortBy, useResizeColumns
  )

  // useEffect(() => {
  //   setGlobalFilter(search);
  // }, [search, setGlobalFilter]);

  return (
    <>
      <GlobalFilter
        preGlobalFilteredRows={preGlobalFilteredRows}
        globalFilter={state.globalFilter}
        setGlobalFilter={setGlobalFilter}
        intl={intl}
      />
      <Table responsive bordered {...getTableProps()}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render('Header')}
                  <span>
                    {column.isSorted
                      ? column.isSortedDesc
                        ? " 🔽"
                        : " 🔼"
                      : ""}
                  </span>
                  <span
                    {...column.getResizerProps()}
                    className={`resizer ${
                      column.isResizing ? "isResizing" : ""
                      }`}
                  />
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row)
            return (
              <React.Fragment>
                <tr {...row.getRowProps()}>
                  {row.cells.map(cell => {
                    return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                  })}
                </tr>
              </React.Fragment>
            )
          })}
        </tbody>
      </Table>
      {/* <pre>
        <code>{JSON.stringify(state, null, 2)}</code>
      </pre> */}
    </>
  )
}


const EmailsTable = ({ data: { data: { emails } }, intl }) => {

  // const [search, setSearch] = React.useState("");

  const columns = [
    {
      accessor: "timestamp",
      Header: intl.formatMessage({
        id: "table.transactions.date",
      }),
      filterable: false,
      Cell: (props) => (
        <div>
          {DateTime.fromMillis(parseInt(props.row.original.timestamp))
            .setLocale(intl.locale)
            .toLocaleString(DateTime.DATETIME_MED)}
        </div>
      ),
    },
    {
      Header: intl.formatMessage({
        id: "heading.speakers"
      }),
      accessor: ({ _id, ...row }) => {
        const sValues = row.speakers;
        return sValues.map( s => Object.values(s).join("|"));
      },
      Cell: (props) => (
        <ul>
          {
            props.row.original.speakers.map(s => (
              <li><span><b>{intl.formatMessage({ id: "input.lastname" })}:</b> {s.name}</span><span><b>{intl.formatMessage({ id: "input.email" })}:</b> {s.email}</span></li>
            ))
          }
        </ul>
      )
    },
    {
      accessor: "emails",
      Header: intl.formatMessage({
        id: "input.email"
      }),
      Cell: (props) => {
        const [showTabs, setShowTabs] = React.useState(false);
        return (
          <React.Fragment>
            <div style={{ minWidth: 505 }}>
              <Button style={{ color: '#fff' }} onClick={() => setShowTabs(!showTabs)} variant="primary"><i className="fas fa-eye"></i></Button>
            </div>
            {
              showTabs ?
                <Tabs
                  id="tabs-with-dropdown"
                  defaultActiveKey={`rich-${props.row.original.timestamp}`}
                // onSelect={(k) => {
                //   setEditing(k);
                // }}
                >
                  <Tab eventKey={`rich-${props.row.original.timestamp}`} title={intl.formatMessage({ id: 'rich.text' })}>
                    <div dangerouslySetInnerHTML={{ __html: props.row.original.email }} />
                  </Tab>
                  <Tab eventKey={`html-${props.row.original.timestamp}`} title="HTML">
                    <code>{props.row.original.email}</code>
                  </Tab>
                </Tabs>
                :
                <div />
            }
          </React.Fragment>
        )
      }
    }
  ]
  return (
    <div>
      <div className="email-table">
        {
          emails.length > 0 ? <ReactTable data={emails} columns={columns} intl={intl} />
        : <div>
            <BSALert variant="warning"><h5 style={{margin: 0}}>{intl.formatMessage({id: 'no.sent.emails'})}</h5></BSALert>
          </div>
        }
        
      </div>
    </div>
  )
}

export default injectIntl(EmailsTable);